import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { RootState } from "../../api/store";

export type PrimaryModalMyTeam = null | 'viewProfile'

export interface MyTeamInitialState {
    primaryModal: PrimaryModalMyTeam,
    searchValueMyTeam: string;
    userId: number | null;
}

const initialState: MyTeamInitialState = {
    primaryModal: null,
    searchValueMyTeam: '',
    userId: null,
};

const myTeamSlice = createSlice({
    name: "myTeamSlice",
    initialState,
    reducers: {
        setPrimaryModalMyTeam: (state, action: PayloadAction<PrimaryModalMyTeam>) => {
            state.primaryModal = action.payload;
        },
        setSearchValueMyTeam: (state, action: PayloadAction<string>) => {
            state.searchValueMyTeam = action.payload;
        },
        setUserIdMyTeam: (state, action: PayloadAction<number | null>) => {
            state.userId = action.payload;
        },
        clearMyTeamState: () => initialState,
    },
});

export const {
    setPrimaryModalMyTeam,
    setSearchValueMyTeam,
    setUserIdMyTeam,
    clearMyTeamState,
} = myTeamSlice.actions;

export default myTeamSlice.reducer;

export const selectPrimaryModalMyTeam = (state: RootState) => state.myTeamSlice.primaryModal;
export const selectSearchValueMyTeam = (state: RootState) => state.myTeamSlice.searchValueMyTeam;
export const selectUserId = (state: RootState) => state.myTeamSlice.userId;